import styled from 'styled-components'
import { Swiper } from 'swiper/react'

export const Container = styled.div`
  margin: 0%;
  padding-top: 4rem;
  padding-bottom: 4rem;
  line-height: 0;
  background: ${({ theme }) => theme.colors.sliderBackground};

  @media screen and (min-width: 768px) {
    &:hover {
      position: relative;
      z-index: 2;
    }
  }
`

export const HeadingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5rem;
  margin-bottom: 1.4rem;

  @media screen and (min-width: 768px) {
    margin-bottom: 4.8rem;
  }
`

export const Title = styled.h2`
  font-size: 2rem;
  line-height: 2.5rem;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.brand};
  text-transform: uppercase;
  text-align: center;

  @media screen and (min-width: 768px) {
    font-size: 2.6rem;
    line-height: 4rem;
    text-align: center;
  }
`

export const SubTitle = styled.div`
  margin: 0.6rem 0 0 0;
  font-size: 1.8rem;
  line-height: 2.2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fonts.brand};
  text-align: center;

  p {
    margin: 0 0 1.5rem 0;
  }

  p,
  a {
    font: inherit;
  }
`

export const StyledSwiper = styled(Swiper)`
  padding-left: 1.6rem;

  ${Container}.sm & {
    padding-left: 2.6rem;

    @media screen and (min-width: 768px) {
      padding-left: 1.6rem;
    }
  }

  .swiper-slide {
    display: flex;
    justify-content: center;

    &:last-child {
      margin-right: 2rem;
    }

    &:hover {
      @media screen and (min-width: 768px) {
        position: relative;
        z-index: 1;
      }
    }

    ${Container}.xs & {
      width: 23rem;
    }

    ${Container}.lg & {
      width: 23rem;

      @media screen and (min-width: 768px) {
        width: 35rem;
      }
    }

    ${Container}.dynamic-size & {
      width: auto;
    }
  }
`

const ArrowContainer = styled.div`
  user-select: none;
  position: absolute;
  top: 35%;
  transform: translate(0, -50%);
  z-index: 20000;
`

export const LeftArrowContainer = styled(ArrowContainer)`
  left: 0;
`

export const RightArrowContainer = styled(ArrowContainer)`
  right: 0;
`
